import { useState } from 'react';

import { BadgeName } from '@app/components/badges/badge-name';
import EmptyState from '@app/components/empty-state';
import TagIcon from '@app/components/icons/tag';
import { T } from '@app/components/translation';

import { ExportModalBase } from '.';
import { TooManyRequests } from './helpers/too-many-requests';
import style from './export.module.scss';

type Props = {
  onExport: (onSuccess: () => void) => void;
  email: string;
  queryCount: number;
};

export const ExportTagsModal = ({ onExport, email, queryCount }: Props) => {
  const [errorStatusCode, setErrorStatusCode] = useState<number | undefined>(undefined);

  const renderBody = () => {
    if (queryCount === 0) {
      return (
        <EmptyState
          icon={<TagIcon height="33px" />}
          header={
            <T
              _str="No tags to export"
              _comment="Empty state header. Shown in tag export modal when having no tags"
            />
          }
          content={
            <T
              _str="Please adjust your search criteria and try again."
              _comment="Empty state content. Shown in export modal when having no data."
            />
          }
          defaultStyle
          className={style.NoData}
        />
      );
    }

    return (
      <>
        <p>
          <T
            _str="The export will include all tags used in this account."
            _comment="Modal body text explaining what the export will include."
          />
        </p>
        <p>
          <T
            _str="The download link will be sent to {userEmail} shortly."
            userEmail={<BadgeName>{email}</BadgeName>}
            _comment="Help text explaining where the email will be sent in the export modal."
          />
        </p>
        <TooManyRequests errorStatusCode={errorStatusCode} />
      </>
    );
  };

  return (
    <ExportModalBase
      tooltip={
        <T
          _str="Export tags"
          _comment="Tooltip text explaining what the export button is for."
        />
      }
      header={
        <T
          _str="Export tags"
          _comment="Confirm modal title for exporting tags."
        />
      }
      onExport={onExport}
      renderBody={renderBody}
      setErrorStatusCode={setErrorStatusCode}
      disabled={!queryCount}
    />
  );
};
